import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { GoogleLogo, ArrowLeft } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate("/admin", { replace: true });
  }, [user, loading, navigate]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex flex-col bg-black text-white relative overflow-hidden">
      <div className="absolute inset-0 noise opacity-[0.1]" />
      <div className="relative flex-1 flex items-center justify-center px-5">
        <div className="w-full max-w-md text-center">
          <a href="/" className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-white transition-colors mb-10">
            <ArrowLeft size={16} /> Back to site
          </a>
          <div className="font-display text-4xl font-black tracking-tighter">Kenny Web Design</div>
          <div className="mt-2 text-[11px] uppercase tracking-[0.3em] text-zinc-500">Admin CMS</div>
          <p className="mt-8 text-zinc-400">Sign in to manage portfolio, testimonials, pricing, and referral codes.</p>
          <button
            data-testid="admin-google-login"
            onClick={login}
            className="mt-8 w-full inline-flex items-center justify-center gap-3 rounded-full bg-white text-black font-medium px-6 py-4 hover:bg-zinc-200 transition-colors"
          >
            <GoogleLogo size={22} weight="bold" /> Continue with Google
          </button>
        </div>
      </div>
    </div>
  );
}
